export default function AlertsPage() {
  return <div style={{ padding: 24 }}><h2>Alerts — Coming Sprint 2</h2></div>
}
